export default "__VITE_ASSET__$P79enQu__"